module.exports = __webpack_public_path__ + "img/3.922b267a.png";